var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowNext333(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "24px",
    viewBox: "0 0 14 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowNext333") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icArrowNext333",
    transform: "translate(6.999998, 11.900000) rotate(180.000000) translate(-6.999998, -11.900000) ",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7045052,11.905031 L13.6194852,3.001122 C13.8649552,2.756543 14,2.429535 14,2.080855 C14,1.731982 13.8649552,1.405167 13.6194852,1.160202 L12.8383052,0.380413 C12.5932152,0.13506 12.2655952,0 11.9164652,0 C11.5673352,0 11.2401052,0.13506 10.9948252,0.380413 L0.380125204,10.981281 C0.133875204,11.227021 -0.000964795584,11.555384 0,11.90445 C-0.000964795584,12.255065 0.133685204,12.583041 0.380125204,12.828974 L10.9849352,23.419587 C11.2302252,23.66494 11.5574552,23.8 11.9067752,23.8 C12.2559052,23.8 12.5831352,23.66494 12.8286152,23.419587 L13.6095952,22.639798 C14.1177952,22.132259 14.1177952,21.306031 13.6095952,20.798685 L4.7045052,11.905031 Z",
    id: "path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowNext333);
export default __webpack_public_path__ + "static/media/icArrowNext333.b3f34da355450bc74b4db27d7bb7d2fd.svg";
export { ForwardRef as ReactComponent };